/**
 * Portrait viewport (aspect ≤ 1:1). Narrow intro→title uses cell enter over
 * the note instead of the desktop cover-fragment wipe.
 *
 * Latched against Android URL-bar height churn; re-samples on orientation or
 * layout-width change — see `latchedMatchMedia`.
 */

import { useSyncExternalStore } from "react";

import { HUB_NARROW_MEDIA } from "@story/data-centers-hub/config/constants";
import {
  getLatchedMatchMediaSnapshot,
  subscribeLatchedMatchMedia,
} from "@story/data-centers-hub/hooks/latchedMatchMedia";

function subscribe(onStoreChange: () => void): () => void {
  return subscribeLatchedMatchMedia(HUB_NARROW_MEDIA, onStoreChange);
}

function getSnapshot(): boolean {
  return getLatchedMatchMediaSnapshot(HUB_NARROW_MEDIA);
}

export function useHubNarrowViewport(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
